import { filterData } from "./Utility";
import customFetch from "./apicall/api";
export const update_payload = async (
  api_token,
  bucket_name,
  payload_key,
  payload
) => {
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "api-token": api_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    };

    const response = await customFetch(
      process.env.REACT_APP_URL +
        "/payload/update/" +
        bucket_name +
        "/" +
        payload_key,
      requestOptions
    );

    if (response.status != 200) throw "Error updating the payload";

    const data = await response.json();
    data["status"] = 1;
    return data;
  } catch (e) {
    console.error(e);
    return { message: "Error updating the payload", status: 0 };
  }
};

const transformKeys = (obj) => {
  // If it's an array, transform each element but keep it as an array
  if (Array.isArray(obj)) {
    return obj.map(item => transformKeys(item));
  }
  
  // If it's null or not an object, return as is
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }
  
  // For regular objects, transform keys
  const transformedObj = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const newKey = key.replace(/:/g, ".");
      transformedObj[newKey] = transformKeys(obj[key]);
    }
  }
  return transformedObj;
};

export const update_mongopayload = async (
  api_token,
  dbname,
  collectionname,
  objectid,
  change_data
) => {
  try {
    const transformedData = transformKeys(change_data);
    cleanBlankKeys(transformedData);
    const requestOptions = {
      method: "POST",
      headers: {
        "api-token": api_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(transformedData),
    };

    const response = await customFetch(
      process.env.REACT_APP_URL +
        "/mongo/updateone/" +
        dbname +
        "/" +
        collectionname +
        "/" +
        objectid,
      requestOptions
    );

    if (response.status != 200) throw "Error updating the payload";

    const data = await response.json();
    return data;
  } catch (e) {
    return { message: "Error updating the payload", status: 0 };
  }
};
export const insert_mongopayload = async (
  api_token,
  dbname,
  collectionname,
  change_data
) => {
  try {
    cleanBlankKeys(change_data);
    const requestOptions = {
      method: "POST",
      headers: {
        "api-token": api_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(change_data),
    };

    const response = await customFetch(
      process.env.REACT_APP_URL +
        "/mongo/insert/" +
        dbname +
        "/" +
        collectionname ,
        
      requestOptions
    );

    if (response.status != 200) throw "Error updating the payload";

    const data = await response.json();
    return data;
  } catch (e) {
    return { message: "Error updating the payload", status: 0 };
  }
};
export const update_mongogrouppayload = async (
  api_token,
  dbname,
  collectionname,
  change_data
) => {
  try {
    console.log("update_mongogrouppayload input:", JSON.stringify(change_data, null, 2));
    const transformedData = transformKeys(change_data);
    transformedData.forEach(item => delete item[""]);
    console.log("After transformKeys:", JSON.stringify(transformedData, null, 2));
    const requestOptions = {
      method: "POST",
      headers: {
        "api-token": api_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(transformedData),
    };

    const response = await customFetch(
      process.env.REACT_APP_URL +
        "/mongo/updateone/" +
        dbname +
        "/" +
        collectionname,
      requestOptions
    );

    if (response.status != 200) throw "Error updating the payload";

    const data = await response.json();
    return data;
  } catch (e) {
    return { message: "Error updating the payload", status: 0 };
  }
};

export const enque_mongopayload = async (
  api_token,
  dbname,
  collectionname,
  change_data
) => {
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "api-token": api_token,
        "Content-Type": "application/json",
        "X-User-Id": localStorage.getItem("in_userid"),
      },
      body: JSON.stringify(change_data),
    };

    const response = await customFetch(
      process.env.REACT_APP_URL +
        "/mongo/enqueue/" +
        dbname +
        "/" +
        collectionname,
      requestOptions
    );

    if (response.status != 200) throw "Error updating the payload";

    const data = await response.json();
    return data;
  } catch (e) {
    return { message: "Error updating the payload", status: 0 };
  }
};

export const delete_mongofield = async (
  api_token,
  dbname,
  collectionname,
  objectid,
  change_data
) => {
  try {
    cleanBlankKeys(change_data);
    const requestOptions = {
      method: "POST",
      headers: {
        "api-token": api_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(change_data),
    };

    const response = await customFetch(
      process.env.REACT_APP_URL +
        "/mongo/delete/" +
        dbname +
        "/" +
        collectionname +
        "/" +
        objectid,
      requestOptions
    );

    if (response.status != 200) throw "Error updating the payload";

    const data = await response.json();
    return data;
  } catch (e) {
    return { message: "Error updating the payload", status: 0 };
  }
};

export const get_payload_config = async (
  api_token,
  effective_designation_id
) => {
  try {
    const formdata = new FormData();
    formdata.append("branch_id", localStorage.getItem("branch_id"));
    formdata.append(
      "effective_designation",
      localStorage.getItem("e_designation_id")
    );
    formdata.append("userid", localStorage.getItem("in_userid"));
    formdata.append("flag", "fetch_user_functionality");
    const requestOptions = {
      method: "POST",
      headers: {
        "api-token": api_token,
      },
      body: formdata,
    };

    const response = await customFetch(
      process.env.REACT_APP_URL + "/permission/data",
      requestOptions
    );
    const data = await response.json();
    if (
      !data.message &&
      data.user_functionality_mapping[0].views &&
      data.user_functionality_mapping[0].views.length > 0
    ) {
      return data.user_functionality_mapping[0].views;
    } else {
      return get_view_config(api_token, effective_designation_id);
    }
  } catch (e) {
    console.error(e);
    return [];
  }
};

const get_view_config = async (api_token, effective_designation_id) => {
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "api-token": api_token,
      },
    };

    const response = await customFetch(
      process.env.REACT_APP_URL +
        "/get/webhook/configuration?effective_designation_id=" +
        effective_designation_id,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const get_payload_views = async (
  api_token,
  bucket_name,
  event_name,
  defaultfilter,
  isLoginuser,
  filterDate,
  event_location,
  searchData,
  searchconfig
) => {
  console.log("defaultfilter->", defaultfilter.length);
  try {
    let payload = "";
    let defaultpayload = [];
    if (event_name != "") {
      defaultpayload = [
        [event_location, "==", event_name],
        ["created_at", ">", filterDate],
      ];
    } else {
      defaultpayload = [["created_at", ">", filterDate]];
    }
    if (isLoginuser == "1") {
      let convertedData = [];
      if (defaultfilter.length > 0 && defaultfilter[0].operatordata == "==") {
        convertedData = defaultfilter.map((item) => [
          item.field,
          "==",
          parseInt(item.fieldvalue),
        ]);
      }
      if (
        defaultfilter.length > 0 &&
        defaultfilter[0].operatordata == "array_contains_any"
      ) {
        convertedData = defaultfilter.map((item) => [
          item.field,
          "array_contains_any",
          item.fieldvalue.split(",").map((num) => parseInt(num)), //[parseInt(item.fieldvalue)],
        ]);
      }
      payload = [...defaultpayload, ...convertedData];
    } else {
      payload = defaultpayload; //[["event", "==", event_name]];
    }
    let payload_search = [...payload, ...searchData];
    let search_data;
    if (searchconfig) {
      let searchvalue = [];
      searchvalue = searchconfig.map((item) => [item[0], item[1], item[2]]);
      search_data = [...payload_search, ...searchvalue];
    } else {
      search_data = payload_search;
    }
    console.log("search_data-->", search_data);
    const requestOptions = {
      method: "POST",
      headers: {
        "api-token": api_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(search_data),
    };

    const response = await customFetch(
      process.env.REACT_APP_URL + "/payload/get/" + bucket_name,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const get_mongo_payload = async (
  api_token,
  search_by_pair,
  filterDate,
  searchconfig,
  dbname,
  collectionname,
  defaultfilter,
  isLoginuser,
  limit_per_call,
  offset,
  filter_columns,
  hideloadmore
) => {
  console.log("defaultfilter", defaultfilter);
  try {
    let payload = "";
    let defaultpayload = [];
    // if (event_name != "") {
    //   defaultpayload = [
    //     [event_location, "==", event_name],
    //     ["created_at", ">", filterDate],
    //   ];
    // } else {
    //   defaultpayload = [["created_at", ">", filterDate]];
    // }
    if (isLoginuser == "1" && defaultfilter.length > 0) {
      let convertedData = [];
      if (defaultfilter[0].operatordata == "==") {
        convertedData = defaultfilter.map((item) => [
          item.field,
          "==",
          parseInt(item.fieldvalue),
        ]);
      }
      if (defaultfilter[0].operatordata == "array_contains_any") {
        convertedData = defaultfilter.map((item) => [
          item.field,
          "in",
          item.fieldvalue.split(",").map((num) => parseInt(num)), //[parseInt(item.fieldvalue)],
        ]);
        console.log("convertedData", convertedData);
      }
      payload = [...defaultpayload, ...convertedData];
    }
    let payload_search = JSON.parse(search_by_pair);
    let splitkeypair = [...payload, ...payload_search];
    if (searchconfig) {
      const elementToAdd = ["issearch", "==", [searchconfig]];
      payload = [...splitkeypair, elementToAdd]; // splitkeypair.push(elementToAdd);
    } else {
      payload = splitkeypair;
    }
    // Add bucketFields to the payload
    if (filter_columns) {
      payload.push(["filter_columns", "==", filter_columns]);
    }

    console.log("payload->", payload);
    const requestOptions = {
      method: "POST",
      headers: {
        "api-token": api_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    };
    let url = "";
    if (hideloadmore == "1") {
      url =
        process.env.REACT_APP_URL +
        "/mongo/get/" +
        dbname +
        "/" +
        collectionname +
        "?limit=" +
        limit_per_call +
        "&offset=" +
        offset;
    } else {
      url =
        process.env.REACT_APP_URL +
        "/mongo/get/" +
        dbname +
        "/" +
        collectionname;
    }
    const response = await customFetch(url, requestOptions);
    const data = await response.json();
    return data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const cache_payload_data = async (update_data,current_data,isLoginuser,defaultfilter,search_by_pair,searchconfig) => {
  let payload = "";
    let defaultpayload = [];    
    if (isLoginuser == "1" && defaultfilter.length > 0) {
      let convertedData = [];
      if (defaultfilter[0].operatordata == "==") {
        convertedData = defaultfilter.map((item) => [
          item.field,
          "==",
          parseInt(item.fieldvalue),
        ]);
      }
      if (defaultfilter[0].operatordata == "array_contains_any") {
        convertedData = defaultfilter.map((item) => [
          item.field,
          "in",
          item.fieldvalue.split(",").map((num) => parseInt(num)), //[parseInt(item.fieldvalue)],
        ]);
        console.log("convertedData", convertedData);
      }
      payload = [...defaultpayload, ...convertedData];
    }
    let payload_search = JSON.parse(search_by_pair);
    let splitkeypair = [...payload, ...payload_search];
    if (searchconfig.rules.length > 0) {
      const elementToAdd = ["issearch", "==", [searchconfig]];
      payload = [...splitkeypair, elementToAdd]; // splitkeypair.push(elementToAdd);
    } else {
      payload = JSON.parse(search_by_pair);
    } 
    console.log("query",payload);

    const updatedData = current_data.map((item) => {
      const update = update_data.find(
        (updateItem) => updateItem.object_id === item._id.$oid
      );

      if (update) {
        // Merge the existing item with the update data
        return {
          ...item,
          ...update,
          ...update.add_data_before,
          _id: item._id, // Preserve the original _id
          //add_data_before: update.add_data_before, // Include add_data_before if needed
        };
      }
      return item;
    });
    const filteredData = applyFilter(updatedData, payload);
    console.log("updatedData",filteredData);
    return filteredData;
}

export const applyFilter = (data, query) => {
  if (!Array.isArray(query) || query.length === 0) return data;

  return data.filter(item => {
    return query.every(condition => {
      if (!Array.isArray(condition) || condition.length < 3) return false;
      const [field, operator, value] = condition;

      if (field === 'issearch') {
        return operator === '==' && evaluateSearchGroups(item, value);
      }

      return evaluateFieldCondition(item, { field, operator, value });
    });
  });
};

export const evaluateSearchGroups = (item, searchConditions) => {
  return searchConditions.some(group => evaluateGroup(item, group));
};

export const evaluateGroup = (item, group) => {
  if (group && typeof group === 'object') {
    if (Array.isArray(group.$and)) return group.$and.every(rule => evaluateGroup(item, rule));
    if (Array.isArray(group.$or)) return group.$or.some(rule => evaluateGroup(item, rule));
  }

  const isCombinatorGroup = group && typeof group === 'object' && ('combinator' in group || Array.isArray(group && group.rules));

  if (isCombinatorGroup) {
    const combinator = group.combinator || 'and';
    const rules = group.rules || [];

    if (combinator === 'and') {
      return rules.every(rule =>
        rule.rules ? evaluateGroup(item, rule) : evaluateRule(item, rule)
      );
    }

    if (combinator === 'or') {
      return rules.some(rule =>
        rule.rules ? evaluateGroup(item, rule) : evaluateRule(item, rule)
      );
    }

    return false;
  }

  //Handle single field conditions (e.g., {"field": {"$exists": true}})
  if (group && typeof group === 'object' && !Array.isArray(group)) {
    return Object.entries(group).every(([field, condition]) => {
      if (typeof condition === 'object' && condition !== null) {
        if ('$exists' in condition) {
          //Deep $exists check
          const itemValue = getNestedValue(item, field);
          const exists = itemValue !== undefined && itemValue !== null;
          return condition.$exists === true ? exists : !exists;
        }

        //Nested logic inside condition (e.g., {"field": {"$gt": 10}})
        const operator = Object.keys(condition)[0];
        const value = condition[operator];
        return evaluateFieldCondition(item, { field, operator, value });
      }

      //Simple field comparison (e.g., {"status": 80})
      return evaluateFieldCondition(item, {
        field,
        operator: '==',
        value: condition
      });
    });
  }

  return false;
};

export const evaluateRule = (item, rule) => {
  const { field, operator, value } = rule;
  return evaluateFieldCondition(item, { field, operator, value });
};

export const evaluateFieldCondition = (item, { field, operator, value }) => {
  const itemValue = getNestedValue(item, field);
  const typedValue = convertValue(itemValue, value);

  switch (operator) {
    case '==': case '=': return itemValue === typedValue;
    case '!=': return itemValue !== typedValue;
    case '>': return itemValue > typedValue;
    case '<': return itemValue < typedValue;
    case '>=': return itemValue >= typedValue;
    case '<=': return itemValue <= typedValue;
    case 'in':
      return Array.isArray(itemValue)
        ? itemValue.some(v => Array.isArray(typedValue) && typedValue.includes(v))
        : Array.isArray(typedValue) && typedValue.includes(itemValue);
    case 'nin':
      return Array.isArray(itemValue)
        ? !itemValue.some(v => Array.isArray(typedValue) && typedValue.includes(v))
        : !Array.isArray(typedValue) || !typedValue.includes(itemValue);
    case 'regex':
      return typeof itemValue === 'string' && new RegExp(typedValue, 'i').test(itemValue);
    case 'exists': {
      //Direct exists check for nested paths
      const exists = itemValue !== undefined && itemValue !== null;
      return typedValue === true || typedValue === 'true'
        ? exists
        : !exists;
    }
    default:
      return false;
  }
};

export const convertValue = (itemValue, ruleValue) => {
  if (Array.isArray(ruleValue)) {
    return ruleValue.map(v => convertSingleValue(itemValue, v));
  }
  return convertSingleValue(itemValue, ruleValue);
};

export const convertSingleValue = (itemValue, ruleValue) => {
  const targetType = typeof itemValue;
  if (targetType === 'number') return Number(ruleValue);
  if (targetType === 'string') return String(ruleValue);
  if (targetType === 'boolean') return ruleValue === 'true' || ruleValue === true;
  return ruleValue;
};

export const getNestedValue = (obj, path) => {
  if (!path || typeof path !== 'string') return undefined;

  //Safely resolve nested fields (e.g., "txn.details.bank_ref_no")
  const keys = path.split('.');
  let result = obj;

  for (let key of keys) {
    if (result == null || typeof result !== 'object' || !(key in result)) {
      return undefined;
    }
    result = result[key];
  }

  return result;
};

const cleanBlankKeys = (obj) => {
  if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
    delete obj[""];
  } else if (Array.isArray(obj)) {
    obj.forEach(item => cleanBlankKeys(item));
  }
}